(() => {
  if (!window.location.pathname.includes('/product-beta-tester-register')) {
    return;
  }

  let email = '';
  let subscirbeFlag = true

  // when user input do cache
  document.addEventListener('input', function (e) {
    if (e.target.matches('input[data-type="email"]')) {
      email = e.target.value.trim().toLowerCase();
    }else if (e.target.matches('input[type="checkbox"]')) {
      subscirbeFlag = e.target.checked;
    }
    
  }, true);

  // use cache value in submit
  document.addEventListener('submit', function (e) {
    if(!subscirbeFlag){
        console.log('user reject subscirbe');
        return
    }
    const form = e.target;
    if (!form.querySelector('#landing-subscribe-form-loaded-flag')) {
        console.log('skip page')
        return;
    }

    if (!email) {
      console.warn('email cache empty');
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      console.warn('email format error');
      return;
    }

    // wait request done
    setTimeout(() => {
        console.log('cached email:', email);
       
        if (document.body.innerText.includes('Thank you')) {
            console.log('find Thank you');
            const storageKey = 'landing_subscribe_' + email;
            if (localStorage.getItem(storageKey)) {
                console.log('landing_subscribe already sent, skip gtag:', email);
                return;
            }
                
            if (typeof gtag === 'function' && email) {
                gtag('event', 'landing_subscribe', {});
                gtag('event', 'sign_up', {});
                localStorage.setItem(storageKey, '1');
                window.itApi.updateCustomerTag(email, 'subscribe_source_landing_page').then(() => {
                    console.log('tag updated');
                }).catch(err => {
                    console.error('tag update failed:', err);
                });
                email = ''
                console.log('landing_subscribe and sign_up triggered', email);
            }
        }else{
            console.log('skip landing_subscribe, request failed');
        }

    }, 3000)

  }, true);
})();